import { render, staticRenderFns } from "./wtlogisticChainList.vue?vue&type=template&id=271b1a10"
import script from "./wtlogisticChainList.vue?vue&type=script&lang=js"
export * from "./wtlogisticChainList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports